import { FormGroup as MuiFormGroup, styled } from '@mui/material';
import { shouldNotForwardProps } from '@/core/helpers';
export const FormGroupStyled = styled(MuiFormGroup, shouldNotForwardProps('gap'))(({ theme, gap, row }) => ({
    ...(row && {
        gap: theme.spacing(6),
    }),
    ...(gap !== undefined && {
        gap,
    }),
}));
